/*
 *     Copyright (c) 2018 Bcame S.r.l. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l.  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="listing-page-container" :class="pageClass">
    <portal to="nav-bottom">
      <change-view-filter :options="changeViewOptions"></change-view-filter>
    </portal>
    <div class="listing-nav">
      <sort-filter-section
      id="sortFilter"
      :currentCategory="category"
      :subCategoryVisible="subCategoryVisible"
      :sort="sort"
      @sortChange="sortChange"
      @changeFilter="changeFilter"
      />
    </div>
    <div v-if="showProducts">
      <section class="list-product">
        <div class="list-container">
          <div v-if="products.length">
            <product-listing :products="products" :columns="columns" />
            <div class="load-more-items">
              <button type="button" class="btn btn-primary btn-primary-small btn-primary-black btn-rounded" v-show="pagination.total !== products.length" @click.prevent="loadMore">{{loadMoreValue}}</button>
            </div>
          </div>
          <div v-else class="nothing-found text-center">
            <h4 class="mx-auto">{{ $t('no-products-found') }}</h4>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import SortFilterSection from 'theme/components/Listing/SortFilterSection'
import ProductListing from 'theme/components/Listing/ProductListing'
import InputSearch from 'theme/components/Listing/InputSearch'
import ChangeViewFilter from 'theme/components/Listing/Dropdown/ChangeViewFilter/ChangeViewFilter'
import Listing from '@/pages/Listing.js'
import Config from 'config'
import filter from 'lodash/filter'
import find from 'lodash/find'
import forEach from 'lodash/forEach'

export default {
  mixins: [Listing],
  data () {
    return {
      handleScroll: 0,
      anchorScrollDefault: '#product-content'
    }
  },
  computed: {
    totals () {
      return this.$store.state.listing.pagination.total
    },
    allCategoriesFlatted () {
      return this.$store.state.category.flatted
    },
    currentCategoryMeta () {
      return this.$store.state.category.metaData
    },
    categoryCustomAttribute () {
      let map = {}
      if (this.category && this.category.custom_attributes) {
        forEach(this.category.custom_attributes, (cat) => {
          map[cat.attribute_code] = cat.value
        })
      }
      return map
    },
    changeViewOptions () {
      let newListingFilter = JSON.parse(JSON.stringify(Config.Theme.listingFilters.dropFilter))
      return newListingFilter
    },
    chViewOptionSelected (attrCode) {
      return this.$store.state.listing[attrCode]
    },
    subCategoryVisible () {
      if (this.category.childrenData && this.category.childrenData.length) {
        return filter(this.category.childrenData, { include_in_menu: true, is_active: true })
      } else if (this.category.parent_id) {
        let categoryParent = find(this.allCategoriesFlatted, { id: this.category.parent_id })
        if (categoryParent) {
          return filter(categoryParent.childrenData, { include_in_menu: true, is_active: true })
        }
      }
    },
    isSearchPage () {
      return !!this.$route.meta.search
    },
    loadMoreValue () {
      let remainig = Config.Theme.paginationSize
      if ((this.pagination.total - this.products.length) <= Config.Theme.paginationSize) {
        remainig = this.pagination.total - this.products.length
      }
      return this.$tc('View {tot} more', remainig, { tot: remainig })
    },
    pageClass () {
      let categoryCustom = this.categoryCustomAttribute && this.categoryCustomAttribute[Config.customAttributes.category.lookCategory] ? `page-${this.categoryCustomAttribute[Config.customAttributes.category.lookCategory]}` : ''
      return [categoryCustom]
    }
  },
  methods: {
    loadMore () {
      //  change page size
      let currentPage = this.pagination.page
      currentPage++
      let incrementableStart = Config.Theme.paginationSize * currentPage
      let pagination = {
        size: Config.Theme.paginationSize,
        start: incrementableStart - Config.Theme.paginationSize,
        page: Math.ceil(incrementableStart / Config.Theme.paginationSize)
      }
      window.pagePosition = null
      this.$store.commit('listing/setPagination', { ...pagination })
      this.changePage(pagination, window.scrollY)
    },
    changePage (pagination, scrollingPos = false) {
      this.$route.query.size = pagination.size
      this.$route.query.start = pagination.start
      this.$route.query.page = pagination.page
      this.changeQuery(this.$route.query).finally(() => {
        let scroll = window.scrollY
        if (scrollingPos) {
          scroll = scrollingPos
        }
        this.pageScrollBehavior(scroll)
      })
    },
    pageScrollBehavior (position = $(this.anchorScrollDefault).offset().top - 60) {
      let pos
      if (window.pagePosition) {
        pos = window.pagePosition
      } else {
        pos = position
      }
      setTimeout(() => {
        $('html, body').animate({
          scrollTop: pos
        }, 300)
      }, 100)
    }
  },
  beforeMount () {
    if (process.client) {
      return this.$store.commit('ui/setHeaderPageTitle', this.category.name)
    }
  },
  mounted () {
    if (process.client && this.showProducts) {
      document.querySelector('.bcm-whole-header .block-navigation .main-navigation .bottom-navigation').style.display = 'block'
      document.querySelector('.wrapp-iterable-content').style.paddingTop = `${document.querySelector('.bcm-whole-header').offsetHeight}px`
    }
  },
  destroyed () {
    if (process.client) {
      document.querySelectorAll('.bcm-whole-header .block-navigation .main-navigation .bottom-navigation, .wrapp-iterable-content').forEach((el) => { el.style = {} })
    }
  },
  components: {
    SortFilterSection,
    ProductListing,
    ChangeViewFilter,
    InputSearch
  }
}
</script>
